import { render, staticRenderFns } from "./CancelTrips.vue?vue&type=template&id=27b8939a"
import script from "./CancelTrips.vue?vue&type=script&lang=ts"
export * from "./CancelTrips.vue?vue&type=script&lang=ts"
import style0 from "./CancelTrips.vue?vue&type=style&index=0&id=27b8939a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports